export default __webpack_public_path__ + "static/media/roboto-v20-latin-500.cea99d3e.woff";